import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";

import CLoseImg from "../../../assets/images/closeIcon.svg";
import "./Export.scss";
import { getOrderCsvApi } from "live-slices/orders/thunk";

const Exportcsv = ({ show, onCloseClick,countPage ,isQuickCommerce}: any) => {
  const dispatch: any = useDispatch();

  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");

  useEffect(() => {
  if (show) {
    setSelectedStatus("");
    setStartDate("");
    setEndDate("");
  }
  console.log(countPage);

}, [show]);

useEffect(() => {
  if (endDate && startDate && dayjs(endDate).isBefore(dayjs(startDate))) {
    setEndDate(""); 
  }
}, [startDate]);

  const statusList = [
    { label: "New Order", value: "orderPlaced" },
    { label: "Ready to Ship", value: "readyToShip" },
    { label: "Shipping", value: "handedOver" },
    { label: "Delivered", value: "delivered" },
    { label: "Canceled", value: "cancelledByBuyer" },
    { label: "Rejected", value: "cancelledBySeller" },
  ];

  const handleStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedStatus(e.target.value);
  };

  const handleExport = async () => {
    if (!startDate || !endDate || !selectedStatus) {
      alert("Please select date range and one order status.");
      return;
    }

    const formattedStartDate = dayjs(startDate).format("MM-DD-YYYY");
    const formattedEndDate = dayjs(endDate).format("MM-DD-YYYY");

    try {
      const response: any = await dispatch(
        getOrderCsvApi({
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          count: countPage,
          status: selectedStatus,
          isQuickCommerce:isQuickCommerce
        })
      );

      const csvContent = response?.payload?.csv;
      if (csvContent) {
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "orders.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        onCloseClick();
      } else {
        alert("CSV content not found.");
      }
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered className="ExportCSV-Modal">
      <ModalBody>
        <img
          data-testing-id="closeIcon"
          onClick={onCloseClick}
          className="closeIconModal"
          src={CLoseImg}
          alt=""
        />
        <div className="export-csv-modal">
          <div className="export-csv-header">
            <h4>Export Orders as CSV</h4>
          </div>
          <div className="export-csv-content">
            <p>Select order status</p>
          </div>

          <div className="export-csv-flex">
            {statusList.map((status) => (
              <div key={status.value} className="export-csv-checkboxes">
                <input
                  type="radio"
                  name="orderStatus" // group name to allow only one selection
                  value={status.value}
                  checked={selectedStatus === status.value}
                  onChange={handleStatusChange}
                />
                <label>{status.label}</label>
              </div>
            ))}
          </div>

          <div className="DFlex">
            <div className="export-csv-Table">
              <div className="date-picker-container">
                <label className="from-date">Select From Date</label>
                <div className="input-wrapper">
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="From Date"
                  />
                </div>
              </div>

              <div className="date-picker-container">
                <label className="from-date">Select To Date</label>
                <div className="input-wrapper">
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="To Date"
                    min={startDate || undefined}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="export-csv-button">
            <button onClick={handleExport}>Export CSV</button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

Exportcsv.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  detailModal: PropTypes.any,
  countPage: PropTypes.number,
  isQuickCommerce:PropTypes.any,
};

export default Exportcsv;
